import './index.css';
import { useEffect, useState, useRef } from 'react';
import FirstPage from "./pages/firstPage"
import SecondPage from './pages/secondPage';
import ThirdPage from './pages/thirdPage';
import { webhookJoinSite } from './utils/webhook';

function getDeviceType() {
    const userAgent = navigator.userAgent;
    if (/Mobi|Android/i.test(userAgent)) {
        return 'mobile';
    }
    return 'desktop';
}

function App() {
    const [deviceType, setDeviceType] = useState(getDeviceType());
    const [loading, setLoading] = useState(true);
    const [page, setPage] = useState(1);
    const pagesCount = 3;

    const music = useRef(null);
    const [musicStarted, setMusicStarted] = useState(false);

    useEffect(() => {
        music.current = new Audio("/musics/mello_a.mp3")
        music.current.volume = 0.05
    }, [])

    function handleMusic() {
        // if (!loading && !musicStarted) {
        //     setMusicStarted(true)
        //     music.current.play()
        // }
    }


    useEffect(() => {
        const handleResize = () => {
            setDeviceType(getDeviceType());
        };
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    function handleLoading() {
        setTimeout(() => {
            setLoading(false)
        }, 1000)

        //Webhook visit alert
        const visited = window.localStorage.getItem("visited")
        if (visited == null) {
            window.localStorage.setItem("visited", "true")
            webhookJoinSite()
        }
        console.log(visited)
    }

    useEffect(() => {
        handleLoading()
    }, [loading])

    function handlePages(pageId) {
        handleLoading()
        setPage(pageId)
    }


    return (
        <>
            {
                deviceType !== 'mobile' ? (
                    <>
                        {!loading ? (
                            <div className='page-div page-div-left'>
                                <button
                                    title={page === 1 ? '' : `Página ${page - 1}`}
                                    className='page-button'
                                    onClick={() => handlePages(page - 1)}
                                    disabled={page === 1}
                                >
                                    ◄
                                </button>
                            </div>
                        ) : null}

                        <main onClick={handleMusic}>
                            {loading ? (
                                <div className="loading">
                                    <div title='dot1'></div>
                                    <div title='dot2'></div>
                                    <div title='dot3'></div>
                                </div>
                            ) : (
                                page === 1 ? (
                                    <FirstPage />
                                ) : page === 2 ? (
                                    <SecondPage />
                                ) : (
                                    <ThirdPage />
                                )
                            )}
                        </main>

                        {!loading ? (
                            <div className='page-div page-div-right'>
                                <button
                                    title={page === pagesCount ? '' : `Página ${page + 1}`}
                                    className='page-button'
                                    onClick={() => handlePages(page + 1)}
                                    disabled={page === pagesCount}
                                >
                                    ►
                                </button>
                            </div>
                        ) : null}
                    </>
                ) :
                    <>
                        <main>
                            <FirstPage />
                        </main>
                    </>
            }
        </>

    );
}

export default App;
